import * as yup from 'yup'

export const LABEL_FAVORECIDO_PADRAO = 'Favorecido'

export const FeatureFlagsSchema = {
  product_fruits: yup
    .object({
      SdkId: yup.string().required(),
      PesquisaSatisfacaoId: yup.string().optional(),
    })
    .required(),

  integracao_papel_zero: yup
    .object({
      label_favorecido: yup.string().default(LABEL_FAVORECIDO_PADRAO),
    })
    .required(),

  indecx: yup
    .object({
      Action: yup.string().required(),
      Widgetkey: yup.string().required(),
    })
    .required(),
} as const

export type FeatureFlags = {
  [K in keyof typeof FeatureFlagsSchema]: yup.InferType<
    (typeof FeatureFlagsSchema)[K]
  >
}
